import axios from 'axios';
import { useAuthStore } from '@/stores/auth';
import { useToast } from 'primevue/usetoast';

const apiBaseUrl = import.meta.env.VITE_API_BASE_URL;

const instance = axios.create({
    baseURL: apiBaseUrl,
    withCredentials: true,
    withXSRFToken: true,
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
});

// Create a simple toast hook
let toast;
export const setToastInstance = (toastInstance) => {
    toast = toastInstance;
};

instance.interceptors.response.use(undefined, err => {
    const error = err.response;

    const authStore = useAuthStore();
    // if error is 401
    if (error?.status === 401 && !authStore.unauthorized) {
        useAuthStore().logout();

        authStore.unauthorized = true;
    }

    if (error?.status === 403) {
        toast.add({
            severity: 'error',
            summary: 'لا تملك صلاحيات',
            detail: error.data.message,
            life: 10000
        });
    }

    return Promise.reject(err);
});

export default instance;
